import { render, staticRenderFns } from "./menu-modal.vue?vue&type=template&id=59a2c30d"
import script from "./menu-modal.vue?vue&type=script&lang=js"
export * from "./menu-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports